import React from "react"
import { Drawer, CircularProgress } from "material-ui"
import { amber50, grey100 } from "material-ui/styles/colors"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { ITimeoffRequestDocument, ETimeoffStatus, ITimeoffNote, IBasicUser } from "../../models"
import * as api from "../../api"
import moment from "moment"
import AuthenticationStore from "../../stores/AuthenticationStore"
import LeftNote from "./LeftNote"
import RightNote from "./RightNote"
import _ from "lodash"
import AppStateStore from "../../stores/AppStateStore"

interface IProps {
  open: boolean
  leaveRequestId: string
  handleClose(): void
}
interface IState {
  leaveRequest: ITimeoffRequestDocument
  leaveRequestNotes: ITimeoffNote[]
  users: IBasicUser[]
  inputNote: string
  sendingNotes: ITimeoffNote[]
  editNote: ITimeoffNote
  updating: boolean
  candidateNoteForPopup: ITimeoffNote
}

export default class LeaveTrackingNotesDrawer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      leaveRequest: null,
      leaveRequestNotes: [],
      users: [],
      inputNote: "",
      sendingNotes: [],
      editNote: null,
      updating: false,
      candidateNoteForPopup: null,
    }
    autobind(this)
  }

  componentDidMount() {
    this.props.leaveRequestId &&
      this.getData(this.props.leaveRequestId)
  }

  componentWillReceiveProps(nextProps: IProps) {
    nextProps.open && nextProps.leaveRequestId &&
      this.getData(nextProps.leaveRequestId)
  }

  async getData(timeoffId: string) {
    const res = await api.getLeaveRequest(timeoffId)
    const leaveRequest = res.data as ITimeoffRequestDocument

    const userIds = []
    userIds.push(leaveRequest.UserId)
    leaveRequest.Notes &&
      leaveRequest.Notes.forEach(item => item.UserId && !userIds.includes(item.UserId) && userIds.push(item.UserId))

    
    const usersRes = await api.getBasicUsers(userIds)

    this.setState({
      leaveRequest,
      leaveRequestNotes: leaveRequest.Notes || [],
      users: usersRes.data
    })
  }

  handleUpdateNote(leaveRequestNotes: ITimeoffNote[], cb) {
    api.updateLeaveRequestNotes(this.state.leaveRequest.Id, leaveRequestNotes).then(() => {
      setTimeout(() => {
        this.setState({ leaveRequestNotes })
        cb && cb()
      }, 1000)
    })
  }

  handleKeyPress(e) {
    if (e.keyCode === 13) {
      const leaveRequestNotes = _.cloneDeep(this.state.leaveRequestNotes)
      if (this.state.editNote) {
        leaveRequestNotes.forEach((note) => {
          if (note.DateTime === this.state.editNote.DateTime && note.Note === this.state.editNote.Note) {
            note.Note = e.target.value
          }
        })
        this.setState({ inputNote: "", updating: true, }, () => {
          this.handleUpdateNote(leaveRequestNotes, () => {
            this.setState({ editNote: null, updating: false })
          })
        })
      }
      else {
        const note: ITimeoffNote = {
          Note: e.target.value,
          DateTime: moment().utc().format(),
          UserId: AuthenticationStore.getLoggedInUser().Id,
          UserName: `${AuthenticationStore.getLoggedInUser().FirstName} ${AuthenticationStore.getLoggedInUser().LastName}`,
          StatusAssociatedWithNote: this.state.leaveRequest.Status
        }
        const sendingNotes = _.cloneDeep(this.state.sendingNotes)
        sendingNotes.push(note)
        leaveRequestNotes.push(note)
        this.setState({ inputNote: "", sendingNotes }, () => {
          this.handleUpdateNote(leaveRequestNotes, () => {
            let sendingNotes1 = _.cloneDeep(this.state.sendingNotes)
            sendingNotes1 = sendingNotes1.filter((item) => item.DateTime !== note.DateTime)
            this.setState({ sendingNotes: sendingNotes1 })
          })
        })
      }
    }
  }

  handleRemoveNote(note: ITimeoffNote, cb) {
    const leaveRequestNotes = this.state.leaveRequestNotes
    const indexOf = leaveRequestNotes.indexOf(note)
    leaveRequestNotes.splice(indexOf, 1)
    this.handleUpdateNote(leaveRequestNotes, cb)
  }

  handleEditNote(editNote: ITimeoffNote) {
    this.setState({ editNote, inputNote: editNote.Note })
  }

  handleClose() {
    this.setState({
      leaveRequest: null,
      leaveRequestNotes: [],
      users: [],
      inputNote: "",
      sendingNotes: [],
      editNote: null,
      updating: false,
      candidateNoteForPopup: null,
    })
    this.props.handleClose()
  }

  render() {
    return (
      <Drawer
        open={this.props.open}
        openSecondary
        width={420}
        docked={false}
        overlayStyle={{ zIndex: 1500 }}
        containerStyle={{ zIndex: 1500, opacity: open ? 1 : 0, transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms" }}
        onRequestChange={this.handleClose}
      >
        <div style={{ backgroundColor: AppStateStore.getDrawerHeaderColor(), height: 70, padding: 15 }}>
          <div style={{ color: amber50, fontSize: 25, fontWeight: 700, marginTop: 25, textAlign: "center" }}>
            {strings.Leave_Tracking_Note_History}
          </div>
          <i
            className="fa fa-close"
            style={{ color: amber50, fontSize: 25, position: "absolute", top: 15, right: 15, cursor: "pointer" }}
            onClick={this.handleClose}
          />
        </div>
        {!this.state.leaveRequest ?
          <div className="spinner"><CircularProgress /></div> :
          <div style={{ padding: 20, fontFamily: "Roboto, sans-serif", fontSize: 13 }}>
            <div>
              <div style={{ display: "flex" }}>
                <div style={{ width: 100 }}>{strings.Name}</div>
                <div>{this.state.leaveRequest.EmployeeName}</div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ width: 100 }}>{strings.Status}</div>
                <div>
                  {this.state.leaveRequest.Status === ETimeoffStatus.Applied ?
                    strings.Applied :
                    this.state.leaveRequest.Status === ETimeoffStatus.Requested ?
                      strings.Requested :
                      this.state.leaveRequest.Status === ETimeoffStatus.Approved ?
                        strings.Approved + " by " + this.state.leaveRequest.Notes.filter((note) => note.StatusAssociatedWithNote === ETimeoffStatus.Approved)[0].UserName :
                        strings.Denied + " by " + this.state.leaveRequest.Notes.filter((note) => note.StatusAssociatedWithNote === ETimeoffStatus.Denied)[0].UserName
                  }
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ width: 100 }}>{strings.Dates}</div>
                <div>
                  {moment(this.state.leaveRequest.StartDate).local().subtract(moment(this.state.leaveRequest.StartDate).utcOffset(), "minutes")
                    .isSame(moment(this.state.leaveRequest.EndDate).local().subtract(moment(this.state.leaveRequest.EndDate).utcOffset(), "minutes"), "day") ?
                    moment(this.state.leaveRequest.StartDate).local().subtract(moment(this.state.leaveRequest.StartDate).utcOffset(), "minutes").format("MM/DD/YYYY") :
                    `${moment(this.state.leaveRequest.StartDate).local().subtract(moment(this.state.leaveRequest.StartDate).utcOffset(), "minutes").format("MM/DD/YYYY")} - 
											${moment(this.state.leaveRequest.EndDate).local().subtract(moment(this.state.leaveRequest.EndDate).utcOffset(), "minutes").format("MM/DD/YYYY")}`
                  }
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ width: 100 }}>{strings.TotalHours}</div>
                <div>{this.state.leaveRequest.TotalHours}</div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ width: 100 }}>{strings.Applied_Hours}</div>
                <div>{this.state.leaveRequest.AppliedHours}</div>
              </div>
            </div>
            <div>
              <div>{strings.Notes}</div>
              <div style={{ borderTop: "1px solid rgb(224, 224, 224)", paddingTop: 20 }}>
                <div style={{ overflowY: "auto", overflowX: "hidden", paddingRight: 10, maxHeight: window.innerHeight - 375 }}>
                  {!this.state.leaveRequestNotes.length && !this.state.sendingNotes.length &&
                    <div style={{ textAlign: "center" }}>{strings.No_Note}</div>
                  }
                  {this.state.leaveRequestNotes.map((note, index) => note.UserId !== AuthenticationStore.getLoggedInUser().Id ?
                    <LeftNote
                      users={this.state.users}
                      note={note}
                      key={index}
                    /> :
                    <RightNote
                      note={note}
                      key={index}
                      handleRemove={this.handleRemoveNote}
                      editState={!this.state.updating && this.state.editNote && this.state.editNote.DateTime === note.DateTime && this.state.editNote.Note === note.Note}
                      handleEdit={this.handleEditNote}
                      showProgress={this.state.updating && this.state.editNote && this.state.editNote.DateTime === note.DateTime && this.state.editNote.Note === note.Note}
                      handleSetCandidateNoteForPopup={(candidateNoteForPopup) => this.setState({ candidateNoteForPopup })}
                      hidePopup={
                        this.state.candidateNoteForPopup &&
                        (this.state.candidateNoteForPopup.DateTime !== note.DateTime || this.state.candidateNoteForPopup.Note !== note.Note)
                      }
                    />
                  )}
                  {this.state.sendingNotes.map((note, index) =>
                    <RightNote
                      note={note}
                      key={index}
                      showProgress={true}
                      editState={false}
                    />
                  )}
                </div>
                <div style={{ display: "table", tableLayout: "fixed", clear: "both", borderTop: "1px solid rgb(224, 224, 224)", width: "100%", paddingTop: 20 }}>
                  <input
                    type="text"
                    value={this.state.inputNote}
                    placeholder={strings.Type_here}
                    style={{ width: 335, border: 0, borderRadius: 20, backgroundColor: grey100, padding: "10px 20px", fontSize: 13, outline: 0, color: "rgb(97, 97, 97)" }}
                    onChange={(e) => this.setState({ inputNote: e.target.value })}
                    onKeyDown={this.handleKeyPress}
                  />
                </div>
              </div>
            </div>
          </div>
        }
      </Drawer>
    )
  }
}